<template>
  <div
    class="main gradient-page-content"
    :style="getGradient"
  >
    <language-button v-if="splashHeaderAllowLocale" />
    <v-container
      class="container-mobile gradient-page d-flex"
    >
      <slot />
    </v-container>
    <footer-wrapper
      class="footer"
      :sac="servicerProfileEmail"
      :servicer="servicerProfile"
    />
  </div>
</template>

<script>
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import FooterWrapper from '../../Landing/Footer/FooterWrapper.vue'
import LanguageButton from '../../Landing/Header/LanguageButton.vue'

export default {
  name: 'GradientWrapper',
  components: {
    FooterWrapper,
    LanguageButton
  },
  computed: {
    themeColor () {
      return this.$vuetify.theme.themes.light.primary
    },
    profileColorLight () {
      return rgbaFromHexAndOpacity(this.themeColor, 0.5)
    },
    profileColorDark () {
      return rgbaFromHexAndOpacity(this.themeColor, 1.0)
    },
    getGradient () {
      return `background: linear-gradient(90deg, ${this.profileColorDark} 0.68%, ${this.profileColorLight} 51.8%, ${this.profileColorDark} 100%);`
    },
    servicerProfileEmail () {
      return this.$route.params.code
    },
    servicerProfile () {
      return this.$store?.servicer
    },
    logoUrl () {
      return this.servicerProfile?.effective_company_logo_url
    },
    splashHeaderAllowLocale () {
      return this.$store.borrowerWebContent?.splashHeaderAllowLocale
    }
  },
  methods: {
    imageAltUrl (event) {
      event.target.src = '/assets/new_home_page/simplenexus-logo-with-slogan.png'
    },
    rgbaFromHexAndOpacity
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.main {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 160px;
  display: flex;
  flex-direction: column;
}
.main::after {
  content: '';
  position: absolute;
  height: calc(100% - 360px - 8px);
  width: 100%;
  background: white;
  top: 360px;
  z-index: 10;
}
.container-mobile {
  position: relative;
  flex: 1;
  z-index: 25;
}

.footer {
  position: relative;
  padding-top: 18px;
  z-index: 20;
}
.gradient-page-content {
  height: 100%;
  flex-direction: column;
  display: flex;
}
.gradient-page {
  flex-grow: 1;
}

@media screen and (max-width: $medium-screen-size) {
  .main::after {
    background-color: $sn-gray-01;
  }
  .container-mobile {
    border-radius: 16px 16px 0 0;
    background-color: $sn-white;
    box-shadow: 0px -5px 15px -5px rgba(0, 0, 0, 0.25);
  }
  .footer {
    background-color: $sn-gray-01;
  }
  // shifts vuetify container 960px breakpoint max-width to match util/vuetify.js breakpoint
  .container {
    max-width: 100%;
  }
}

@media screen and (min-width: ($medium-screen-size + 1)) {
  .container-mobile {
    max-width: 560px;
  }
}
</style>
